import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccountListingComponent } from './account-listing/account-listing.component';
import { AccountFormComponent } from './account-form/account-form.component';
import { BranchLisitngComponent } from './branch-lisitng/branch-lisitng.component';
import { BranchFormComponent } from './branch-form/branch-form.component';
import { UserListingComponent } from './user-listing/user-listing.component';
import { UserFormComponent } from './user-form/user-form.component';

const routes: Routes = [

  {
    path: '', pathMatch: 'full', redirectTo: 'account-listing'
  },
  {
    path: 'account-listing',
    component: AccountListingComponent
  },
  {
    path: 'account-create',
    component: AccountFormComponent
  },
  {
    path: 'account-edit/:id',
    component: AccountFormComponent
  },
  {
    path: 'branch-listing',
    component: BranchLisitngComponent
  },
  {
    path: 'branch-create',
    component: BranchFormComponent
  },
  {
    path: 'branch-edit/:id',
    component: BranchFormComponent
  }, 
   {
    path: 'user-listing',
    component: UserListingComponent
  },
  {
    path: 'user-create',
    component: UserFormComponent
  },
  {
    path: 'user-edit/:id',
    component: UserFormComponent
  },
  
  
  
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ManagementRoutingModule { }
